import { gettext } from '@eventbrite/i18n';
import { Stack, Typography } from '@eventbrite/marmalade';
import { TimeSlotList, TimeSlotProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../../utils/rebrand';
import defaultStyles from '../TimeSlot.module.scss';
import rebrandStyles from '../TimeSlot.rebranding.module.scss';
import { getDurationString } from '../utils';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

type TimeSessionProps = {
    sessions: Array<TimeSlotProps>;
    duration: string;
    onSessionClick: (sessionId: string, sessionLabel: string) => void;
    isAppRebrandActive: boolean;
    selectedSessionId: string;
};

const TimeSlotSelector: FC<TimeSessionProps> = ({
    sessions,
    onSessionClick,
    duration,
    isAppRebrandActive,
    selectedSessionId,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];
    function handleSessionClick(timeSlot: TimeSlotProps) {
        onSessionClick(timeSlot.id, timeSlot.startDatetime);
    }

    const durationText = gettext('Duration: %(duration)s', {
        duration: getDurationString(Number(duration)),
    }).toString();

    return (
        <Stack space="spacing-md" className={styles.timeSlotContainer}>
            <Typography
                variant="body-md-bold"
                color="neutral-800"
                className={styles.durationText}
                data-testid="duration-text"
            >
                {durationText}
            </Typography>
            <TimeSlotList
                timeSlots={sessions}
                handleTimeClick={handleSessionClick}
                selectedId={selectedSessionId}
                selectedSlotClassName={styles.selectedSlot}
                disabledSlotClassName={styles.disabledSlot}
            />
        </Stack>
    );
};

export default TimeSlotSelector;
